export enum TableColumnType {
  Text = "Text",
  ShortPatientProfile = "ShortPatientProfile",
  Activity = "Activity",
  Custom = "Custom",
  Profile = "Profile",
  ProgressBadge = "ProgressBadge",
  ProgressBarMini = "ProgressBarMini",
  AvatarGroup = "AvatarGroup",
  MultiLines = "MultiLines",
}
